// src/features/dashboard/components/ManagerDashboard/AtRiskAssociate/AtRiskHeader.tsx

const AtRiskHeader = () => {
  return (
    <div className="mb-5 flex flex-wrap items-center gap-3">

      <h1
        className="
          text-[16px]
          font-bold
          text-[#003E7E]
          leading-none
        "
      >
        At-Risk Associates
        <span className="ml-2 text-[#003E7E]">
          · 14 of 48
        </span>
      </h1>

      <div
        className="
          rounded-full
          bg-[#EAF2FF]
          px-4
          py-2
          text-[10px]
          font-medium
          text-[#2563EB]
        "
      >
        Down from 18 last week ·
        Karthik Subramanian ·
        WTD 04 May
      </div>

    </div>
  );
};

export default AtRiskHeader;